<template>
  <div id="raft-js">
    <b-container fluid>
      <router-view />
      <notifications position="bottom right" group="alerts" />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "IncidentManagement",
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
